module.exports = __webpack_public_path__ + "static/media/bell.a9b54a2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/bell.mp3
// module id = b4e4
// module chunks = 1